import { useQuery, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import { useState } from 'react';
import { api } from '../../lib/api';

interface Modelo {
  nome: string;
  idioma: string;
  status: string;
  categoria: string;
  texto: string;
  variaveis: number;
  motivo: string | null;
}

const STATUS: Record<string, { rotulo: string; classe: string }> = {
  APPROVED: { rotulo: 'Aprovado', classe: 'ok' },
  PENDING: { rotulo: 'Em análise', classe: 'espera' },
  REJECTED: { rotulo: 'Recusado', classe: 'ruim' },
  PAUSED: { rotulo: 'Pausado', classe: 'ruim' },
  DISABLED: { rotulo: 'Desativado', classe: 'ruim' },
};

const CATEGORIA: Record<string, string> = {
  UTILITY: 'Utilidade',
  MARKETING: 'Marketing',
  AUTHENTICATION: 'Autenticação',
};

const comVariaveis = (texto: string) =>
  texto.split(/(\{\{\d+\}\})/g).map((p, i) =>
    /^\{\{\d+\}\}$/.test(p) ? (
      <span key={i} className="modelo-var">
        {p}
      </span>
    ) : (
      p
    ),
  );

export function Modelos() {
  const qc = useQueryClient();
  const [atualizando, setAtualizando] = useState(false);
  const modelos = useQuery({ queryKey: ['modelos'], queryFn: () => api<Modelo[]>('/api/modelos') });

  async function atualizar() {
    setAtualizando(true);
    try {
      qc.setQueryData(['modelos'], await api<Modelo[]>('/api/modelos?atualizar=1'));
    } finally {
      setAtualizando(false);
    }
  }

  return (
    <div className="config-cartao largo">
      <header className="com-acao">
        <div>
          <h2>Modelos de mensagem</h2>
          <p>
            Mensagens aprovadas pela Meta, usadas pra falar com o cliente depois que a janela de 24h
            fecha. Utilidade custa bem menos que marketing.
          </p>
        </div>
        <button className="btn" disabled={atualizando} onClick={() => void atualizar()}>
          <RefreshCw className={atualizando ? 'girando' : ''} /> Atualizar
        </button>
      </header>
      {modelos.isLoading ? (
        <p className="nota-sec">Carregando…</p>
      ) : modelos.error ? (
        <p className="erro-form">{(modelos.error as Error).message}</p>
      ) : !modelos.data?.length ? (
        <p className="nota-sec">Nenhum modelo criado na Meta ainda.</p>
      ) : (
        <ul className="lista-modelos">
          {modelos.data.map((m) => {
            const st = STATUS[m.status] ?? { rotulo: m.status, classe: 'espera' };
            return (
              <li key={`${m.nome}-${m.idioma}`}>
                <div className="modelo-topo">
                  <b className="mono">{m.nome}</b>
                  <span className={`modelo-status ${st.classe}`}>{st.rotulo}</span>
                  <span className={`modelo-cat ${m.categoria === 'MARKETING' ? 'caro' : ''}`}>
                    {CATEGORIA[m.categoria] ?? m.categoria}
                  </span>
                </div>
                <p className="modelo-texto">{comVariaveis(m.texto)}</p>
                {m.motivo && <p className="erro-form">Motivo da recusa: {m.motivo}</p>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
